"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetCustomerPurchaseAnalyticsQuery = exports.useGetCustomerMonthlyAnalyticsQuery = exports.useGetCustomerAverageAnalyticsQuery = exports.useGetCustomerLifetimeAnalyticsQuery = exports.customerAnalyticsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var base_query_1 = require("./base_query");
var customerAnalyticsApi = (0, react_1.createApi)({
    reducerPath: "customerAnalyticsApi",
    baseQuery: (0, base_query_1.authorisedBaseQuery)((_a = process.env.LETS_TRADE_BASKET_URL) !== null && _a !== void 0 ? _a : ""),
    refetchOnMountOrArgChange: 30,
    refetchOnFocus: true,
    tagTypes: ["CustomerAnalytics"],
    endpoints: function (builder) { return ({
        getCustomerLifetimeAnalytics: builder.query({
            query: function (userId) { return ({ url: "v2/user/lifetime/analitycs", params: { user_id: userId } }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, userId) { return [{ type: "CustomerAnalytics", id: userId }]; },
        }),
        getCustomerAverageAnalytics: builder.query({
            query: function (userId) { return ({ url: "v2/user/average/analitycs", params: { user_id: userId } }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, userId) { return [{ type: "CustomerAnalytics", id: userId }]; },
        }),
        getCustomerMonthlyAnalytics: builder.query({
            query: function (userId) { return ({ url: "v2/user/monthly/average/analitycs", params: { user_id: userId } }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, userId) { return [{ type: "CustomerAnalytics", id: userId }]; },
        }),
        getCustomerPurchaseAnalytics: builder.query({
            query: function (userId) { return ({ url: "v2/user/purchase/date/analitycs", params: { user_id: userId } }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, userId) { return [{ type: "CustomerAnalytics", id: userId }]; },
        }),
    }); },
});
exports.customerAnalyticsApi = customerAnalyticsApi;
var useGetCustomerLifetimeAnalyticsQuery = customerAnalyticsApi.useGetCustomerLifetimeAnalyticsQuery, useGetCustomerAverageAnalyticsQuery = customerAnalyticsApi.useGetCustomerAverageAnalyticsQuery, useGetCustomerMonthlyAnalyticsQuery = customerAnalyticsApi.useGetCustomerMonthlyAnalyticsQuery, useGetCustomerPurchaseAnalyticsQuery = customerAnalyticsApi.useGetCustomerPurchaseAnalyticsQuery;
exports.useGetCustomerLifetimeAnalyticsQuery = useGetCustomerLifetimeAnalyticsQuery;
exports.useGetCustomerAverageAnalyticsQuery = useGetCustomerAverageAnalyticsQuery;
exports.useGetCustomerMonthlyAnalyticsQuery = useGetCustomerMonthlyAnalyticsQuery;
exports.useGetCustomerPurchaseAnalyticsQuery = useGetCustomerPurchaseAnalyticsQuery;
